import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * テキストノードのみを1文字ずつspanで分割する関数（タグは保持）
 * @param {HTMLElement} element - 分割対象の要素
 * @returns {Array} - 分割されたspan要素の配列
 */
const splitTextToChars = (element) => {
  const chars = [];
  
  // 子ノードを再帰的に処理する関数
  const processNode = (node) => {
    // テキストノードの場合
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const fragment = document.createDocumentFragment();
      
      // 1文字ずつspanで囲む
      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        const span = document.createElement('span');
        span.classList.add('char');
        
        // スペースや改行の場合
        if (char === ' ') {
          span.innerHTML = '&nbsp;';
        } else if (char === '\n') {
          span.innerHTML = '<br>';
        } else {
          span.textContent = char;
        }
        
        // inline-blockにして個別にアニメーション可能にする
        span.style.display = 'inline-block';
        
        fragment.appendChild(span);
        chars.push(span);
      }
      
      // 元のテキストノードを分割したspanに置き換え
      node.parentNode.replaceChild(fragment, node);
    }
    // 要素ノードの場合（タグ）
    else if (node.nodeType === Node.ELEMENT_NODE) {
      // brタグやその他のタグはそのまま保持
      if (node.tagName.toLowerCase() === 'br') {
        // brタグはそのまま
        return;
      }
      
      // 子ノードを再帰的に処理
      const childNodes = Array.from(node.childNodes);
      childNodes.forEach(child => processNode(child));
    }
  };
  
  // ルート要素の子ノードを処理
  const childNodes = Array.from(element.childNodes);
  childNodes.forEach(node => processNode(node));
  
  return chars;
};

const ScrollCopy = () => {
  // すべてのアニメーション対象要素を取得
  const titleElements = document.querySelectorAll('.js-animatedTitle');
  
  titleElements.forEach((titleEl, index) => {
    const mainCopy = titleEl.querySelector('.js-mainCopy');
    const subCopy = titleEl.querySelectorAll('.js-subCopy');
    
    // メインコピーが存在する場合、テキストを分割
    if (mainCopy) {
      // JavaScriptでテキストを1文字ずつ分割（タグは保持）
      const chars = splitTextToChars(mainCopy);
      
      // 初期状態を設定
      gsap.set(chars, {
        yPercent: 100,
        opacity: 0
      });
      
      // subCopyが存在する場合のみ初期状態を設定
      if (subCopy.length > 0) {
        gsap.set(subCopy, {
          y: 10,
          opacity: 0
        });
      }
      
      // タイムラインの作成
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: titleEl,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none none',
          // markers: true,
        }
      });
      
      // メインコピーの文字を順番にアニメーション
      tl.to(chars, {
        yPercent: 0,
        opacity: 1,
        duration: .8,
        stagger: 0.05,
        ease: 'power4.inOut'
      });
      
      // サブコピーが存在する場合のみアニメーション
      if (subCopy.length > 0) {
        tl.to(subCopy, {
          opacity: 1,
          y: 0,
          duration: 0.4,
          stagger: 0.1,
          ease: 'power2.in'
        }, '-=0.4');
      }
    }
  });
};

const init = () => {
  ScrollCopy();
};

export default init;